import { Component } from '@angular/core';

@Component({
  selector: 'app-tos',
  templateUrl: './tos.component.html',
  styleUrl: './tos.component.scss'
})
export class TosComponent {

}
